<div *ngIf="chartOption" echarts [options]="chartOption" class="demo-chart" [theme]="_chartTheme" [ngClass]="{ 'working-hours-chart': isWorkingHoursChart }"></div>
